// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--ZN7g6","label":"_4f720283bf--label--Omj7M"};